import styled from 'styled-components/macro';

import TextBase from '@components/common/core/DataDisplay/Text';

export const PendingOrders = styled(TextBase)`
  line-height: 120%;
  color: ${({ theme }) => theme.colors.gray[1]};
`;

export const ApprovedOrders = styled(TextBase)`
  line-height: 120%;
  color: ${({ theme }) => theme.colors.green.default};
`;

export const OrdersLabel = styled(TextBase)`
  line-height: 120%;
  color: ${({ theme }) => theme.colors.gray[2]};
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
  overflow: hidden;
`;
